<template>
    <v-card flat>
        <v-card-title>
            Listado
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
            </v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="bases" :search="search" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
            <template v-slot:item.cod_base="{ item }">
                <router-link :to="'/bases/' + item.cod_base">{{
                    item.cod_base
                }}</router-link>
            </template>
            <template v-slot:item.fda="{ item }">
                <v-simple-checkbox v-model="item.fda" disabled></v-simple-checkbox>
            </template>
            <template v-slot:item.green_strength="{ item }">
                <v-simple-checkbox v-model="item.green_strength" disabled></v-simple-checkbox>
            </template>
            <template v-slot:item.prioritario="{ item }">
                <v-simple-checkbox v-model="item.prioritario" disabled></v-simple-checkbox>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editBase(item.cod_base)">mdi-pencil</v-icon>
                <v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogDelete" persistent max-width="400">
            <v-card>
                <v-card-title class="text-h5">
                    {{ itemToDelete.cod_base }}
                </v-card-title>
                <v-card-text>¿Estás seguro de querer borrar la Base?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialogDelete = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="deleteBase(itemToDelete.cod_base)">
                        Borrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from "vuex";
import BasesDataService from "@/services/BasesDataService";

export default {
    name: "BasesList",
    data: () => ({
        bases: [],
        search: '',
        sortBy: 'cod_base',
        sortDesc: false,
        headers: [
            { text: 'Codigo', value: 'cod_base' },
            { text: 'Descripcion', value: 'descripcion' },
            { text: 'Decimales', value: 'decimales' },
            { text: 'Dureza', value: 'dureza' },
            { text: 'FDA', value: 'fda' },
            { text: 'Green Strength', value: 'green_strength' },
            { text: 'Prioritario', value: 'prioritario' },
            { text: "Actions", value: "actions", sortable: false },
        ],
        dialogDelete: false,
        itemToDelete: {},
    }),
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        retrieveBases() {
            BasesDataService.getAll()
                .then((response) => {
                    // console.log("BASES"); console.log(response.data);
                    this.bases = response.data.map(this.getDisplayBase);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        editBase(id) {
            this.$router.push({ name: "BaseId", params: { id: id } });
        },
        deleteBase(id) {
            BasesDataService.delete(id)
                .then(() => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.retrieveBases();
                    this.dialogDelete = false
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        getDisplayBase(base) {
            return {
                cod_base: base.cod_base,
                descripcion: base.descripcion,
                decimales: base.decimales,
                dureza: base.dureza,
                fda: base.fda,
                green_strength: base.green_strength,
                prioritario: base.prioritario,
            };
        },
        showDeleteDialog(item) {
            this.itemToDelete = item
            this.dialogDelete = !this.dialogDelete
        },
    },
    mounted() {
        this.retrieveBases();
    }
};
</script>